import { defineMessages } from '@jutro/locale';

export default defineMessages({
    activityReports: {
        id: 'ml.gateway.views.mlPELandingPage.ActivityReports.Activity Reports',
        defaultMessage: 'Activity Reports'
    },
    agentFollowUps: {
        id: 'ml.gateway.views.mlPELandingPage.AgentFollowUps.Agent Follow-ups',
        defaultMessage: 'Agent Follow-ups'
    },
    viewAllFollowUps: {
        id: 'ml.gateway.views.mlPELandingPage.AgentFollowUps.VIEW ALL FOLLOW-UPS',
        defaultMessage: 'VIEW ALL FOLLOW-UPS'
    },
    producerNews: {
        id: '"ml.gateway.views.mlPELandingPage.producerNews.Producer News',
        defaultMessage: 'Producer News'
    },
    viewAllProducerNews: {
        id: 'ml.gateway.views.mlPELandingPage.producerNews.VIEW ALL ARTICLES',
        defaultMessage: 'VIEW ALL ARTICLES'
    }
});
